import { DEFAULT_CACHE_KEY, generateCacheTTL } from '../../utils/functions/cache';
import {
  UPDATE_CLIENT_POLICIES_CURRENT_CACHE_KEY,
  GET_CLIENTSPOLICIES_API_REQUEST,
  GET_CLIENTSPOLICIES_API_SUCCESS,
  GET_CLIENTSPOLICIES_API_ERROR,
  GET_NEXT_CLIENTSPOLICIES_SUCCESS,
} from '../../constants/clientsPoliciesActionNames';
import {
  RENEW_POLICY_API_SUCCESS,
  AMEND_POLICY_API_SUCCESS,
} from '../../constants/renewalActionNames';
import { SELECT_CLIENTS_SUCCESS } from '../../constants/authActionNames';
import {
  ADD_RENEWAL_TO_CART_API_SUCCESS,
  PAY_NOW_API_SUCCESS,
  PAY_FIRST_PREMIUM_API_SUCCESS,
  MAKE_FAC_PAYMENT_API_SUCCESS,
} from '../../constants/cartActionNames';

import { RESET_INSURANCE } from '../../constants/portfolio/insuranceActionNames';

import { RESET_INFINITE_SCROLL_SUCCESS } from '../../constants/miscActionNames';

import payloadData from './payloadData';
import {
  uuidv4,
  dateToString,
  isoStringToDate,
  stringQuoteToDate,
  getAllKeys,
  getKeys,
  uniq,
  anonymizePayload,
} from '../../utils/functions';
import { anonymizeStorage, persistKey, statusOk } from '../../utils/variables';

import { createPolicies } from '../portfolio/insurance';
import { getLocalStorage } from '../../storage/localStorage';
// .slice(0, loadClientsCount)
let searchKeys = [];

const createPayload = (payloadArray, startIndex = 0, lobTypes) => {
  if (!Array.isArray(payloadArray)) return null;
  searchKeys = [];
  const newClientPolicies = createPolicies(payloadArray, lobTypes);
  newClientPolicies.map((object, index) => {
    const newKeys = getKeys(object);
    searchKeys = [...searchKeys, ...newKeys];
    searchKeys = uniq(searchKeys);
    return object;
  });

  /*
  newClientPolicies.sort((a, b) => {
    if (a.canRenewStatusNumber === b.canRenewStatusNumber) {
      // Price is only important when cities are the same
      return b.statusNumber - a.statusNumber ? 1 : -1;
    }
    return b.canRenewStatusNumber > a.canRenewStatusNumber ? 1 : -1;
  });
  */
  // newClientPolicies.sort((a, b) => {
  //     return b.slug > a.slug ? 1 : -1;
  // });

  return newClientPolicies;
};

export const initialState = {
  selectedClient: null,
  isPending: false,
  isError: false,
  isSuccess: false,
  response: null,
  error: null,
  allRows: [],
  count: 0,
  nextItemCount: 0,
  nextScrollCount: 0,
  nextStartIndex: 0,
  searchKeys,
  [persistKey]: null,
  total: {},
  [DEFAULT_CACHE_KEY]: null,
  currentCacheKey: '',
};
// createPayload(payloadData, 0)

export const getPayloadResponse = () => {
  // // console.log('params: ', params);
  return { payload: [{ clientPolicies: payloadData, count: 100000 }] };
};

function clientPoliciesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CLIENTSPOLICIES_API_REQUEST:
      return {
        ...state,
        isPending: true,
        isError: false,
        isSuccess: false,
      };
    case GET_CLIENTSPOLICIES_API_SUCCESS: {
      const startIndex = state?.allRows?.length;
      const lobTypes = action?.lobTypes;
      const rowPayload = createPayload(
        action?.payload?.payload?.result?.data || [],
        startIndex,
        lobTypes,
      );
      const newRows = rowPayload;
      const body = action?.body;
      const cacheKey = action?.cacheKey;
      // console.log('body: ', body);
      const newTotal = action?.payload?.payload?.result?.total || 0;
      const response = action?.payload;
      const isError = response?.responseType !== statusOk;

      const nextStartIndex = body?.nextStartIndex;
      const nextScrollCount = body?.nextScrollCount;
      const nextItemCount = body?.nextItemCount;

      const count = typeof state?.count === 'object' ? { ...state?.count } : {};
      count[cacheKey] = newTotal;

      return {
        ...state,
        isPending: false,
        isSuccess: true,
        isError,
        response, // newPortfolio,
        searchKeys,
        allRows: newRows,
        count,
        // insuranceCollections,
        firstTime: false,
        nextItemCount,
        nextScrollCount,
        nextStartIndex,
        currentCacheKey: cacheKey,
        [DEFAULT_CACHE_KEY]: {
          ...(state[DEFAULT_CACHE_KEY] || {}),
          [cacheKey]: {
            time: generateCacheTTL(),
            payload: response,
          },
        },
      };
    }

    case GET_CLIENTSPOLICIES_API_ERROR:
      return {
        ...state,
        isPending: false,
        isError: true,
        isSuccess: false,
        error: action?.payload,
      };

    case UPDATE_CLIENT_POLICIES_CURRENT_CACHE_KEY:
      return {
        ...state,
        currentCacheKey: action?.payload,
      };

    case GET_NEXT_CLIENTSPOLICIES_SUCCESS: {
      const nextStartIndex = action?.payload?.nextStartIndex;
      const nextScrollCount = action?.payload?.nextScrollCount;
      const nextItemCount = action?.payload?.nextItemCount;

      return {
        ...state,

        nextItemCount,
        nextScrollCount,
        nextStartIndex,
      };
    }

    case RESET_INFINITE_SCROLL_SUCCESS: {
      return {
        ...state,

        nextItemCount: 0,
        nextScrollCount: 0,
        nextStartIndex: 0,
      };
    }

    case RENEW_POLICY_API_SUCCESS:
      return {
        ...state,
        [DEFAULT_CACHE_KEY]: null,
        [persistKey]: null,
      };

    case ADD_RENEWAL_TO_CART_API_SUCCESS:
      return {
        ...state,
        [persistKey]: null,
      };
    case AMEND_POLICY_API_SUCCESS:
      return {
        ...state,
        [DEFAULT_CACHE_KEY]: null,
        [persistKey]: null,
      };
    case PAY_NOW_API_SUCCESS:
      return {
        ...state,
        [DEFAULT_CACHE_KEY]: null,
        [persistKey]: null,
      };

    case PAY_FIRST_PREMIUM_API_SUCCESS:
      return {
        ...state,
        [DEFAULT_CACHE_KEY]: null,
        [persistKey]: null,
      };

    case MAKE_FAC_PAYMENT_API_SUCCESS:
      return {
        ...state,
        [DEFAULT_CACHE_KEY]: null,
        [persistKey]: null,
      };

    case SELECT_CLIENTS_SUCCESS: {
      return {
        ...state,
        total: 0,
        allRows: initialState.allRows,
        [persistKey]: null,
      };
    }

    case RESET_INSURANCE: {
      return {
        ...state,
        [persistKey]: null,
        [DEFAULT_CACHE_KEY]: null,
        allRows: [],
      };
    }

    default:
      return state;
  }
}

export default clientPoliciesReducer;
